import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  description: {
    color: "#2D2D39",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 4,
    wordBreak: "break-word",
  },
  Description: {
    overflow: "hidden",
    textOverflow: "ellipses",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    wordBreak: "break-all",
  },
  Tasklistbox: {
    alignItems: "center",
    display: "flex",
    background: "#FFFFFF",
    borderBottom: `1px solid  ${theme.palette.customColor.LINE}`,
    marginBottom: "0px",
    padding: "10px 0px",
    "&:last-child": {
      borderBottom: 0,
    },
  },
  headerItem: {
    "&.header": {
      borderBottom: `1px solid  ${theme.palette.customColor.LINE}`,
      padding: "15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& .link": {
        color: theme.palette.customColor.SECONDARY,
        textDecoration: "none",
        whiteSpace: "nowrap",
        marginLeft: "10px",
        fontSize: "12px",
        "&:hover": {
          color: theme.palette.customColor.TERTIARY,
          textDecoration: "underline",
        },
      },
    },
  },
}));
